import ClassesBookList from './parts/list';
import { ClassesBookLoader } from './provider/ClassesBookLoader';

const ClassesBook = () => {
  return (
    <ClassesBookLoader>
      <ClassesBookList />
    </ClassesBookLoader>
  );
};

export default ClassesBook;
